import React from 'react';
import PropTypes from 'prop-types';

import RawButon from './styled-components';

const Button = ({ label, onClick, type, disabled, name, primary }) => (
  <RawButon onClick={onClick} type={type} disabled={disabled} name={name} primary={primary}>
    {label}
  </RawButon>
);

Button.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  primary: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'reset', 'submit'])
};

Button.defaultProps = {
  type: 'button',
  disabled: false,
  primary: false
};

export default Button;



// WEBPACK FOOTER //
// ./src/views/common/components/Button/index.jsx